import type {
  ExistingMemberBindingPayload,
  MemberPortalOnboardingApplyPayload,
  MemberPortalOnboardingStatus,
  MemberPortalReferral,
  ResidenceArea,
} from '@/types/api'
import { request } from '@/utils/request'

export const submitOnboardingApplication = (data: MemberPortalOnboardingApplyPayload) =>
  request<MemberPortalOnboardingStatus>({
    data,
    method: 'POST',
    url: '/member-portal/onboarding/applications',
  })

export const getOnboardingStatus = () =>
  request<MemberPortalOnboardingStatus>({
    method: 'GET',
    url: '/member-portal/onboarding/status',
  })

export const bindExistingMember = (data: ExistingMemberBindingPayload) =>
  request<MemberPortalOnboardingStatus>({
    data,
    method: 'POST',
    url: '/member-portal/onboarding/existing-member-binding',
  })

export const sendOnboardingSmsCode = (phone: string, phoneCode?: string) =>
  request<void>({
    data: { phone, phoneCode },
    method: 'POST',
    url: '/member-portal/onboarding/sms-codes',
  })

export const getOnboardingReferral = (referralCode: string) =>
  request<MemberPortalReferral>({
    method: 'GET',
    url: `/member-portal/onboarding/referrals/${encodeURIComponent(referralCode)}`,
  })

export const getOnboardingResidenceAreas = () =>
  request<ResidenceArea[]>({
    method: 'GET',
    url: '/member-portal/onboarding/residence-areas',
  })
